import { XIcon } from 'components/ui/icons';
import TextField from 'components/ui/TextField';
import React from 'react';
import { Icon, Loader } from 'semantic-ui-react';
import { NameToSearch } from '../AutomateNamesTypes';

interface PropTypes {
  name: NameToSearch;
  idx: number;
  handleNameChange: (event: React.ChangeEvent<HTMLInputElement>, label: string, id: number) => void;
  handleDelete: (indexToRemove: number) => void;
}

export const NameToAutomate = (props: PropTypes) => {
  return (
    <div style={{ display: 'flex', gap: 8, marginTop: props.idx > 0 ? 16 : 0 }} key={props.name.id}>
      <div
        style={{ marginTop: 14, cursor: 'pointer', zIndex: 50 }}
        onClick={() => props.handleDelete(props.idx)}
      >
        <XIcon />
      </div>
      <TextField
        placeholder="First Name"
        value={props.name.firstName}
        onChange={e => props.handleNameChange(e, 'firstName', props.name.id)}
      />
      <TextField
        placeholder="Middle Name"
        value={props.name.middleName}
        onChange={e => props.handleNameChange(e, 'middleName', props.name.id)}
        width="170px"
      />
      <TextField
        width="270px"
        placeholder="Last/Business/Estate Name"
        value={props.name.lastName}
        onChange={e => props.handleNameChange(e, 'lastName', props.name.id)}
      />
      {props.name.ran && !props.name.failed && (
        <div>
          <div style={{ marginTop: 14 }}>
            <Icon name="check" color="green" />
          </div>
        </div>
      )}
      {props.name.ran && props.name.failed && (
        <div style={{ marginTop: 14 }}>
          <Icon name="x" color="red" />
        </div>
      )}
      {props.name.loading && (
        <div style={{ marginTop: 14 }}>
          <Loader inline size="small" active />
        </div>
      )}
    </div>
  );
};
